/**
 * Input — primitive de contrôle text/email/password/number/tel/url.
 *
 * Pas de prop `label` / `error` — toujours wrappé par <Field>.
 */

import { forwardRef, type InputHTMLAttributes } from 'react'

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  type?: 'text' | 'email' | 'password' | 'number' | 'tel' | 'url' | 'search' | 'date'
}

const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = 'text', ...rest },
  ref,
) {
  const classes = ['ui-input', className].filter(Boolean).join(' ')
  return <input ref={ref} type={type} className={classes} {...rest} />
})

export default Input
